import React, { useState, useEffect, useRef } from 'react';

const ImageUploadModal = ({ isOpen, setIsOpen, onSave }) => {
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen && fileInputRef.current) {
      fileInputRef.current.focus();
    }
  }, [isOpen]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!imageFile) {
      alert("Please upload an image.");
      return;
    }

    // 🔄 Pass imageFile back to parent if needed
    onSave?.(imageFile);

    // Reset and close modal
    setImageFile(null);
    setPreviewUrl(null);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setImageFile(null);
    setPreviewUrl(null);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={handleCancel}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          <div className="oms-form-group">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
               ref={fileInputRef}
              className="oms-form-input"
            />
            {previewUrl && (
              <img
                src={previewUrl}
                alt="Preview"
                className="mt-2 rounded-md max-h-48 object-contain border"
              />
            )}
          </div>

          <div className="oms-form-actions flex justify-end gap-2 mt-4">
            <button
              type="button"
              className="oms-button oms-button-cancel"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="oms-button oms-button-save"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImageUploadModal;
